const quantityInputs = document.querySelectorAll('.custom_varinat_quantity');
quantityInputs.forEach(input => {
  input.addEventListener('input', (e) => {
    if (e.target.value < 0) {
      e.target.value = 0; 
    }
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === '-' || e.key === 'e') {
      e.preventDefault(); 
    }
  });
});
//price update 

 document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const arrow = header.querySelector('.arrow');

      
      if (content.style.display === "none" || content.style.display === "") {
        content.style.display = "block";
               
      arrow.classList.remove('fa-chevron-down'); 
                arrow.classList.add('fa-chevron-up');
      } else {
        content.style.display = "none";
        arrow.classList.add('fa-chevron-down'); 
                arrow.classList.remove('fa-chevron-up');
 
      }
    });
  });
 document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM loaded. Initializing elements...");

    const quantityInputs = document.querySelectorAll(".custom_varinat_quantity");
    const subtotalElement = document.querySelector(".subtotal_amount");
    const addToCartButton = document.querySelector(".custom_variant_collection");

    function calculateSubtotal() {
      console.log("Calculating subtotal...");
      let subtotal = 0;

      quantityInputs.forEach((input, index) => {
        const parentDiv = input.closest(".price_quantity");
        const variantPrice = parseFloat(
          parentDiv.querySelector(".custom_variant_price").dataset.variantPrice
        );
        console.log(`Variant ${index + 1} price: ${variantPrice}`);

        const quantity = parseInt(input.value) || 0;
        console.log(`Variant ${index + 1} quantity: ${quantity}`);

        const variantTotal = variantPrice * quantity;
        console.log(`Variant ${index + 1} total: ${variantTotal}`);

        subtotal += variantTotal;
        console.log(`Updated subtotal after variant ${index + 1}: ${subtotal}`);
      });

      const formattedSubtotal = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(subtotal);

      console.log(`Formatted subtotal: ${formattedSubtotal}`);
      subtotalElement.innerText = formattedSubtotal;
    }

  
    // Add event listeners to quantity inputs
    quantityInputs.forEach((input, index) => {
      console.log(`Adding event listener to quantity input ${index + 1}`);
      input.addEventListener("input", calculateSubtotal);
    });

    // Add to Cart Button Click Event
    addToCartButton.addEventListener("click", function (evt) {

      evt.preventDefault();
      evt.stopImmediatePropagation();
      console.log("Add to Cart button clicked. Preparing cart data...");

      let formData = {
        items: []
      };
 const jobTagValue = document.querySelector("#job-tag")?.value.trim();
      const cutLengthValue = document.querySelector("#cut-length")?.value.trim();

      
      quantityInputs.forEach((input) => {
        const quantity = parseInt(input.value) || 0;

        if (quantity > 0) {
          const parentDiv = input.closest(".custom_variant_data");
          
           const variantId = input.dataset.variantId;
          
          // const variantId = parentDiv.dataset.variantId;

        let item = {
        id: parseInt(variantId),
        quantity: quantity
      };

      if (jobTagValue) {
        item.properties = {
          "Job/Tag": jobTagValue
        };
      }

             if (cutLengthValue) {
        item.properties = {
       'Cut Length': cutLengthValue
        };
      }else if(document.querySelector("#cut-length") != null){
               alert('Cut Length is required');
               return;
      }
        

      formData.items.push(item);

          console.log(`Added variant ID ${variantId} with quantity ${quantity}`);
        }
      });

      if (formData.items.length > 0) {
        console.log("Sending cart data to Shopify API:", formData);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(data => {
            console.log("Cart updated:", data);
            window.location.href = "/cart";
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
      }
    });
// $('.custom_variant_data .variant_title').click(function(){
// $(`.options-color[data-value="${$(this).data('title')}"]`).click();
//    });
// $('.custom_varinat_quantity').on("focus",function(){
//   $(`.options-color[data-value="${$(this).data('title')}"]`).click();
// })

$('.custom_variant_data .variant_title, .custom_variant_data .custom_variant_title').click(function(){
  var containerIndex = $(this).data('option');
  var value = $(this).data('title');
  var $container = $('.tt-swatches-container .tt-wrapper').eq(containerIndex);
  var $targetSwatch = $container.find('ul li a').filter(function(){
    return $(this).data('value') == value;
  });
  if($targetSwatch.length){
    $targetSwatch.click();
  }
});

$('.custom_varinat_quantity').on("focus", function(){
  var containerIndex = $(this).data('option');
  var value = $(this).data('title');
  var $container = $('.tt-swatches-container .tt-wrapper').eq(containerIndex);
  var $targetSwatch = $container.find('ul li a').filter(function(){
    return $(this).data('value') == value;
  });
  if($targetSwatch.length){
    $targetSwatch.click();
  }
});



   
  });